import React, {ReactNode} from "react";
import {SnackbarProvider} from "notistack";
import infoFill from "@iconify/icons-eva/info-fill";
import alertCircleFill from "@iconify/icons-eva/alert-circle-fill";
import alertTriangleFill from "@iconify/icons-eva/alert-triangle-fill";
import checkmarkCircle2Fill from "@iconify/icons-eva/checkmark-circle-2-fill";
import {SnackbarStyles, SnackbarIcon, CloseSnackbarButton} from "./Components";

type NotistackProviderProps = {
  children: ReactNode;
};

export default function NotistackProvider({children}: NotistackProviderProps) {
  return (
    <>
      <SnackbarStyles />
      <SnackbarProvider
        dense
        maxSnack={5}
        autoHideDuration={3000}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        iconVariant={{
          success: <SnackbarIcon icon={checkmarkCircle2Fill} color="success" />,
          error: <SnackbarIcon icon={infoFill} color="error" />,
          warning: <SnackbarIcon icon={alertTriangleFill} color="warning" />,
          info: <SnackbarIcon icon={alertCircleFill} color="info" />,
        }}
        action={(key) => <CloseSnackbarButton snackbarKey={key} />}
      >
        {children}
      </SnackbarProvider>
    </>
  );
}
